import React, { useEffect, useState } from 'react';
import { getPackageDataBCategorySlug } from '../../../services/holiday/holidayServices';
import { useParams } from 'react-router-dom';
import PackageDetails from './PackageDetails';


const HolidayConfirm = () => {

    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [packageData, setPackageData] = useState({});

    const fetchPackageData = () => {
        setLoading(true);
        getPackageDataBCategorySlug(id)
            .then((response) => {
                setPackageData(response);
                console.log("response", response);
            })
            .catch((error) => {
                setError(error.message || "An error occurred while fetching package data.");
            })
            .finally(() => {
                setLoading(false);
            });
    };
    useEffect(() => {
        fetchPackageData();
    }, []);


    return (
        <>
            <PackageDetails packageData={packageData} loading={loading} />
        </>
    )
}

export default HolidayConfirm
